import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  TemplateRef,
} from '@angular/core';
import { cartOpenButtonAnimations } from '@shared/cart/cart-control/cart-open-button.animations';
import { CartOpenButtonImports } from '@shared/cart/cart-control/cart-open-button.imports';
import { EnMinWidthScreen } from '@shared/constants/screen-breakpoints';

@Component({
  selector: 'noda-cart-open-button',
  imports: CartOpenButtonImports,
  templateUrl: './cart-open-button.component.html',
  styleUrl: './cart-open-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: cartOpenButtonAnimations,
})
export class CartOpenButtonComponent {
  public arrowTemplateRef: InputSignal<TemplateRef<HTMLElement>> =
    input<TemplateRef<HTMLElement>>();
  public counter: InputSignal<number> = input<number>();

  public clicked: OutputEmitterRef<void> = output();
  protected readonly enMinWidthScreen: typeof EnMinWidthScreen = EnMinWidthScreen;
}
